import { render, staticRenderFns } from "./DiscoverPreview.vue?vue&type=template&id=62c53176&scoped=true"
import script from "./DiscoverPreview.vue?vue&type=script&lang=js"
export * from "./DiscoverPreview.vue?vue&type=script&lang=js"
import style0 from "./DiscoverPreview.vue?vue&type=style&index=0&id=62c53176&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c53176",
  null
  
)

export default component.exports